/* eslint-disable no-extend-native */
declare global {
  interface String {
    toTitleCase(): string;
    toCapitalCase(): string;
    encodeURI(): string;
  }
}

String.prototype.toTitleCase = function (): string {
  if (!this) return "";
  return this[0].toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.toCapitalCase = function (): string {
  if (!this) return "";

  return this.toLocaleLowerCase("es-AR").replace(/\b\p{L}/gu, (char) =>
    char.toLocaleUpperCase("es-AR"),
  );
};

String.prototype.encodeURI = function (): string {
  if (!this) return "";
  return encodeURI(this.toString()).replace("(", "%28").replace(")", "%29");
};

export {};
